module.exports = __webpack_public_path__ + "static/img/swiper12.10aa2f94.png";